import { ContentLength } from "../types";

export const CONTENT_LENGTH_OPTIONS = {
    Facebook: [ContentLength.Short, ContentLength.Medium, ContentLength.Long],
    Instagram: [ContentLength.Short],
    Twitter: [ContentLength.Short, ContentLength.Medium, ContentLength.Long],
    LinkedIn: [ContentLength.Short, ContentLength.Medium, ContentLength.Long],
    Pinterest: [ContentLength.Short],
    Google: [ContentLength.Short],
    YouTube: [ContentLength.Short, ContentLength.Medium, ContentLength.Long],
};
